import worldIcon from '../../../assets/worldIcon.png'

interface CriteriaItem {
    id: number
    code: string
}

interface CountryCriteriaDetailProps {
    id: number
    name: string
    criterial_list: CriteriaItem[]
}

export const CountryCriteriaDetail = ({
    criterial_list,
}: CountryCriteriaDetailProps) => {
    return (
        <div className="flex items-center gap-2">
            <div className="flex items-center">
                <img src={worldIcon} alt="country icon" />
                <h3 className="text-[#141A1F] text-[14px] font-normal ml-2">
                    País:
                </h3>
            </div>

            <div className="ml-2">
                <ul className="flex flex-wrap gap-2 items-center">
                    {criterial_list && criterial_list.length > 0 ? (
                        criterial_list.map((item) => (
                            <li
                                key={item.id}
                                className="flex items-center text-[#141A1F] text-[14px] font-normal"
                            >
                                <span className="bg-[#F1F5F9] text-[#3E5060] rounded px-2 py-1 text-sm">
                                    {item.code}
                                </span>
                            </li>
                        ))
                    ) : (
                        <p className="text-gray-400 text-sm">
                            No hay países seleccionados
                        </p>
                    )}
                </ul>
            </div>
        </div>
    )
}
